import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import {
  MatDialogActions,
  MatDialogClose,
  MatDialogTitle,
  MatDialogContent,
} from '@angular/material/dialog';

@Component({
    selector: 'app-dlg-delete',
    imports: [
        MatDialogModule,
        MatButtonModule,
        MatDialogActions,
        MatDialogClose,
        MatDialogTitle,
        MatDialogContent
    ],
    templateUrl: './dlg-delete.component.html',
    styleUrl: './dlg-delete.component.scss'
})
export class DlgDeleteComponent {
  constructor(
    public dialogRef: MatDialogRef<any>
  ) { }

  close() {
    this.dialogRef.close(1);
  }
}
